// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__HUVxp","modalBody":"MealsPop_modalBody__y+BLN"};